
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class HypnoticSpiralsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const count = Math.floor(15 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                ctx.save();
                ctx.rotate(i * 0.1 + curTime);
                ctx.beginPath();
                ctx.lineWidth = (1 + i * 0.5) * scale * (1 / (layerIndex + 1));
                const r = i * 20 * scale;
                ctx.arc(0, 0, r, 0, Math.PI * 1.5);
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
